import { Entity } from '@debbie/common/dist/index.js';
import { Direction, InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useUserById } from '@debbie/cortex/dist/users/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import FileIcon from '../Icons/File.js';
import { Inbox, Phone } from '../Icons/index.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import CallInteraction from './CallInteraction.js';
import EmailInteraction from './EmailInteraction.js';
import NoteInteraction from './NoteInteraction.js';
import RecipientContent from './RecipientContent.js';
const CreditorContactPerson = (props) => {
    const tenant = useTenant();
    const creditorLoadable = useCreditor(props.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const userLoadable = useUserById(creditor?.contactId ?? undefined);
    const user = h.hasData(userLoadable) ? userLoadable.data : null;
    const collectorLoadable = useCollector(tenant?.collectorIdentityId);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    const emailTo = user && user.email;
    if (!(creditor && collector)) {
        return (React.createElement("div", null,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(PlaceholderLoader, { width: "80%" }),
            React.createElement(PlaceholderLoader, { width: "35%" }),
            React.createElement(PlaceholderLoader, { width: "66%" })));
    }
    const tabs = [
        {
            children: (React.createElement(EmailInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor, isDebtor: true, emailTo: emailTo })),
            icon: Inbox,
            label: lang.interactionTypes.EMAIL,
            shouldHide: !emailTo || !emailServer,
        },
        {
            children: (React.createElement(CallInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor })),
            icon: Phone,
            label: lang.interactionTypes.PHONE,
        },
        {
            children: (React.createElement(NoteInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor, options: {
                    direction: Direction.OUTGOING,
                    type: InteractionType.Note,
                }, sendButtonText: lang.interactions.addNote })),
            icon: FileIcon,
            label: lang.interactionTypes.NOTE,
        },
    ];
    return React.createElement(RecipientContent, { tabs: tabs });
};
export default CreditorContactPerson;
//# sourceMappingURL=CreditorContactPerson.js.map